module.exports = __webpack_public_path__ + "img/3.36a57e24.jpg";